module.exports = __webpack_public_path__ + "img/landing_box33.a2941be3.jpg";